<template>
    <path d="M2.49984 3H17.4998C17.7209 3 17.9328 3.0878 18.0891 3.24408C18.2454 3.40036 18.3332 3.61232 18.3332 3.83333V17.1667C18.3332 17.3877 18.2454 17.5996 18.0891 17.7559C17.9328 17.9122 17.7209 18 17.4998 18H2.49984C2.27882 18 2.06686 17.9122 1.91058 17.7559C1.7543 17.5996 1.6665 17.3877 1.6665 17.1667V3.83333C1.6665 3.61232 1.7543 3.40036 1.91058 3.24408C2.06686 3.0878 2.27882 3 2.49984 3ZM16.6665 6.53167L10.0598 12.4483L3.33317 6.51333V16.3333H16.6665V6.53167ZM3.759 4.66667L10.0507 10.2183L16.2515 4.66667H3.759Z"
          fill="#B6C3D1"/>
</template>

<script>
    export default {
        name: 'icon-mail'
    }
</script>